import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTO_CANCELLED } from "../utility-functions/index";
import ReactivateSubscription from "./design/components/ReactivateSubscription";

const SubscriptionGuard = ({ tabName }) => {
  const status = useSelector((state) => state?.account?.value?.subscription?.status);

  if (status === AUTO_CANCELLED) {
    return <ReactivateSubscription tabName={tabName} />;
  }

  return <Outlet />;
};

export default SubscriptionGuard;
